import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext(null);

const STORAGE_KEY = "cnp_lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem(STORAGE_KEY) || "en";
    }
    return "en";
  });

  const setLang = (l) => {
    setLangState(l);
    try {
      localStorage.setItem(STORAGE_KEY, l);
    } catch (e) {
      /* ignore */
    }
  };

  useEffect(() => {
    const map = { en: "en", zh: "zh-Hant", cn: "zh-Hans" };
    document.documentElement.lang = map[lang] || "en";
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
